﻿/*
 * Globalize Culture sl-SI
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("sl-SI", "default", {
    name: "sl-SI",
    englishName: "Slovenian (Slovenia)",
    nativeName: "slovenski (Slovenija)",
    language: "sl",
    numberFormat: {
      ",": ".",
      ".": ",",
      negativeInfinity: "-neskončnost",
      positiveInfinity: "neskončnost",
      percent: {
        pattern: ["-n%", "n%"],
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": ".",
        ".": ",",
        symbol: "€"
      }
    },
    calendars: {
      standard: {
        "/": ".",
        firstDay: 1,
        days: {
          names: [
            "nedelja",
            "ponedeljek",
            "torek",
            "sreda",
            "četrtek",
            "petek",
            "sobota"
          ],
          namesAbbr: ["ned", "pon", "tor", "sre", "čet", "pet", "sob"],
          namesShort: ["ne", "po", "to", "sr", "če", "pe", "so"]
        },
        months: {
          names: [
            "januar",
            "februar",
            "marec",
            "april",
            "maj",
            "junij",
            "julij",
            "avgust",
            "september",
            "oktober",
            "november",
            "december",
            ""
          ],
          namesAbbr: [
            "jan",
            "feb",
            "mar",
            "apr",
            "maj",
            "jun",
            "jul",
            "avg",
            "sep",
            "okt",
            "nov",
            "dec",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "d.M.yyyy",
          D: "d. MMMM yyyy",
          t: "H:mm",
          T: "H:mm:ss",
          f: "d. MMMM yyyy H:mm",
          F: "d. MMMM yyyy H:mm:ss",
          M: "d. MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Dodatna pomoč",
      AddNewTab: "Dodaj nov zavihek",
      Alerts: "Opozorila",
      ApplyFilter: "Uporabi filter",
      Approve: "Odobri",
      Attachments: "Priloge",
      Back: "Nazaj",
      Basic: "Osnovno",
      Between: "Med",
      Book: "Knjiga",
      Cancel: "Prekliči",
      Checked: "Potrjeno",
      ClearFilter: "Počisti filter",
      Close: "Zapri",
      CloseCancelChanges: "Zapri in prekliči spremembe",
      CloseSaveChanges: "Zapri in shrani spremembe",
      CloseTab: "Zapri zavihek",
      ColumnPersonalization: "Prilagajanje stolpca",
      Comments: "Komentarji",
      Confirmation: "Potrditev",
      Contains: "Vsebuje",
      CreateTab: "Ustvari nov zavihek",
      Cut: "Izreži",
      Delete: "Izbriši",
      DiscardUndo: "Zavrzi/razveljavi",
      DisplayDropDownList: "Prikaži spustni seznam",
      Displaying: "Prikazovanje: ",
      DocWord: "Dokument",
      DoesNotContain: "Ne vsebuje",
      DoesNotEndWith: "Se ne konča z",
      DoesNotEqual: "Ni enako",
      DoesNotStartWith: "Se ne začne z",
      Download: "Prenesi",
      Duplicate: "Podvoji",
      Edit: "Uredi",
      EitherSelectedorNotSelected: "Izbrano ali ni izbrano",
      Email: "E-pošta",
      EndsWith: "Se konča z",
      EqualsStr: "Je enako",
      ExpandCollapse: "Razširi/strni",
      ExportFailed: "Izvoz ni uspel",
      ExportToExcel: "Izvozi v Excel",
      FileInUse: "Navedena datoteka je v uporabi",
      FileInUseDetail:
        "Zaprite datoteko v aplikaciji, v kateri se uporablja, ali navedite drugo ime datoteke.",
      Filter: "Filter",
      FilterMenu: "Meni filtra",
      FilterOptions: "Možnosti filtra",
      FilterWithinResults: "Filter v rezultatih",
      First: "Prvi",
      FirstView: "Prvi pogled",
      Folder: "Mapa",
      ForgotPassword: "Ste pozabili svoje geslo?",
      Forward: "Posreduj",
      GetMoreRows: "Pridobi več vrstic",
      GreaterThan: "Večji od",
      GreaterThanOrEquals: "Večji od ali enak",
      GridSettings: "Nastavitve mreže",
      GroupSelection: "Izbira skupine",
      Help: "Pomoč",
      HideColumn: "Skrij stolpec",
      IsEmpty: "Je prazen",
      IsNotEmpty: "Ni prazen",
      Last: "Zadnji",
      LastView: "Zadnji pogled",
      LaunchActivate: "Zaženi/aktiviraj",
      LessThan: "Manjši od",
      LessThanOrEquals: "Manjši od ali enak",
      Links: "Povezave",
      ListTabs: "Navedi vse zavihke",
      LoadingItem: "Nalaganje elementa ",
      Maintenance: "Vzdrževanje",
      Menu: "Meni",
      New: "Novo",
      Next: "Naprej",
      NextView: "Naslednji pogled",
      No: "Ne",
      NotChecked: "Ni potrjeno",
      Notes: "Opombe",
      NotSelected: "Ni izbrano",
      Of: " od ",
      Ok: "V redu",
      Open: "Odpri",
      Password: "Geslo",
      Paste: "Prilepi",
      Phone: "Telefon",
      PleaseWait: "Prosimo, počakajte",
      Previous: "Prejšnji",
      PreviousView: "Prejšnji pogled",
      Print: "Natisni",
      Queries: "Poizvedbe",
      Redo: "Uveljavi",
      Refresh: "Osveži",
      Reject: "Zavrni",
      RememberMe: "Zapomni si me v tem računalniku",
      Reports: "Poročila",
      Reset: "Ponastavi",
      Review: "Preglej",
      RunFilter: "Zaženi filter",
      RunJob: "Zaženi posel",
      Save: "Shrani",
      SaveBeforeClosing: "Shrani pred zapiranjem",
      SavedFilters: "Shranjeni filtri",
      SaveSubmit: "Shrani/predloži",
      ScreenDesign: "Načrt zaslona",
      Search: "Išči",
      SelectContents: "Izberi vsebine",
      SelectDate: "Izberi datum",
      SelectDeselect: "Izberi vse/počisti vse",
      Selected: "Izbrano: ",
      ServerName: "Ime strežnika",
      Settings: "Nastavitve",
      ShowFilterRow: "Prikaži vrstico filtra",
      SignIn: "Vpis",
      SortAscending: "Razvrsti naraščajoče",
      SortDescending: "Razvrsti padajoče",
      Spreadsheet: "Preglednica",
      StartsWith: "Začne se z",
      StatusIndicator: "Indikator stanja",
      Tasks: "Opravila",
      Today: "Danes",
      Translate: "Prevedi",
      UserID: "ID uporabnika",
      Utilities: "Pripomočki",
      Yes: "Da",
      Page: "Stran",
      Rows: "Vrstice",
      ShowingAll: "Prikazuje vse",
      SessionNavigation: "Krmarjenje po seji",
      ListAllMenuItems: "Navedi vse menijske elemente",
      NoRecordsFound: "Noben zapis ni bil najden",
      SearchTree: "Iskalno drevo",
      Clear: "Počisti",
      DrillDown: "Prikaži na ravni z več podrobnostmi",
      Required: "To polje je zahtevano",
      Available: "Na voljo:",
      Add: "Dodaj",
      MoveDown: "Premakni navzdol",
      MoveUp: "Premakni navzgor",
      Remove: "Odstrani",
      LastYear: "Prejšnje leto",
      NextMonth: "Naslednji mesec",
      NextWeek: "Naslednji teden",
      NextYear: "Naslednje leto",
      OneMonthAgo: "Pred enim mesecem",
      OneWeekAgo: "Pred enim tednom",
      SixMonthsAgo: "Pred šestimi meseci",
      Time: "Čas",
      CannotBeSelected: "Te vrstice ni mogoče izbrati.",
      ResetToDefault: "Ponastavi na privzeto postavitev",
      CloseOtherTabs: "Zapri druge zavihke",
      EmailValidation: "Vnesi veljaven e-poštni naslov",
      UrlValidation: "Vnesi veljaven URL",
      EndofResults: "Konec rezultatov",
      More: "Več ...",
      RecordsPerPage: "Zapisov na stran",
      Maximize: "Povečajte",
      Minimize: "Minimiranje"
    }
  });
})(this);
